"use strict";

exports.__esModule = true;
exports["default"] = ShareIcon;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ShareIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 31 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.533 20.435a5.263 5.263 0 0 0-2.303 1.327l-8.667-4.994a5.24 5.24 0 0 0-.014-2.566l8.681-5.001a5.265 5.265 0 0 0 2.303 1.327c2.847.761 5.773-.925 6.533-3.765A5.32 5.32 0 0 0 24.295.242c-2.847-.76-5.772.925-6.533 3.765a5.268 5.268 0 0 0-.055 2.44l-8.789 5.066a5.28 5.28 0 0 0-2.144-1.175c-2.843-.759-5.77.925-6.531 3.765a5.324 5.324 0 0 0 3.772 6.521 5.328 5.328 0 0 0 4.919-1.165l8.773 5.057a5.255 5.255 0 0 0 .055 2.44c.76 2.84 3.686 4.526 6.533 3.765a5.321 5.321 0 0 0 3.771-6.521 5.331 5.331 0 0 0-6.533-3.765z"
  }));
}